const getPictogramContents = (logoSite) => {
  let folderOverride = "";
  let pictogramOverride = "";

  switch (logoSite) {
    case "ANTS":
    case "MAIRIE":
      folderOverride = "document";
      pictogramOverride = "document";
      break;
    case "IMMAT":
    case "PHA":
      folderOverride = "document";
      pictogramOverride = "vehicle-registration";
      break;
    case "PASSEPORT_CNI":
      folderOverride = "document";
      pictogramOverride = "national-identity-card-passport";
      break;
    case "PERMIS":
    case "AUTO_ECOLE":
      folderOverride = "document";
      pictogramOverride = "driving-license-new";
      break;
    case "application":
      folderOverride = "digital";
      pictogramOverride = "application";
      break;
    case "passeport":
      folderOverride = "document";
      pictogramOverride = "passport";
      break;
    case "carte-permis":
      folderOverride = "document";
      pictogramOverride = "driving-licence";
      break;
    case "police":
      folderOverride = "institutions";
      pictogramOverride = "police";
      break;
    case "comedec":
      folderOverride = "buildings";
      pictogramOverride = "city-hall";
      break;
    default:
      break;
  }

  return { folderOverride, pictogramOverride };
};

export default getPictogramContents;
